import { SelectPicker, InputGroup } from 'rsuite';
import { FormGroup } from '@shared/ui/forms/display';
import { icons } from '@shared/static/icons';
import { useTranslation } from 'react-i18next';
import { getUserRole } from '@shared/static/roles';
import { getTotalCards } from '@utils/helpers';
import { CounterIcon } from '@shared/ui/parts';

export default function MemberRoleView({ label, member, error }) {
  const { t } = useTranslation();

  return (
    <FormGroup label={label} error={error}>
      <InputGroup className="has-value" disabled>
        <SelectPicker
          valueKey="id"
          className="twoLinesSelect"
          labelKey="name"
          data={[member]}
          value={member.id}
          disabled
          block
          caret={false}
          renderValue={(label, item) => (
            <div className="twoLinesSelect-item">
              <div className="twoLinesSelect-left">{icons['user-input']}</div>
              <div>
                <p className="primary-text">{item.name}</p>
                <p className="secondary-text">
                  {t(getUserRole(item.group_role))}
                </p>
              </div>
              <CounterIcon
                icon="card-input"
                value={getTotalCards(item)}
                hasBg
              />
            </div>
          )}
        />
      </InputGroup>
    </FormGroup>
  );
}
